import Button, {ButtonVariant} from "@/app/_components/Button";
import {useRouter} from "next/navigation";
import {Heading} from "react-aria-components";
import useSignOutHref from "@/app/_components/layout/useSignOutHref";
import AnchorButton from "@/app/_components/AnchorButton";

const StudentModalBody = () => {
	const router = useRouter();
	const signOutHref = useSignOutHref();
	return (
		<div className="flex flex-col gap-6 px-4 py-10">
			<Heading level={2}>Please Sign Out Before Continuing</Heading>
			<p>
				{/* TODO Strapify */}
				Thank you for showing interest in AoPS Academy! We cannot process your
				request to start the admission process without the permission of a
				parent or guardian. Please log out of your student&apos;s account before
				continuing.
			</p>
			<div className="flex justify-end gap-4">
				<AnchorButton variant={ButtonVariant.NAVY} href={signOutHref}>
					Sign Out
				</AnchorButton>
				<Button
					variant={ButtonVariant.GRAY_SECONDARY}
					onClick={() => {
						router.back();
						router.prefetch("/");
						setTimeout(() => {
							// Should only happen if the back() failed
							router.push("/");
						}, 500);
					}}
				>
					Go Back
				</Button>
			</div>
		</div>
	);
};

export default StudentModalBody;
